/*eslint-disable */
export const defaultProductsPerPageForMobile = 24;

export const numberOfSkeletonLoader = 48;
